module.exports = "\n<my-app-sidenav></my-app-sidenav>\n<section id=\"page-container\" class=\"app-page-container\">\n    <my-app-header></my-app-header>\n\n    <div class=\"app-content-wrapper\">\n        <div class=\"app-content\">\n            <div class=\"full-height\">\n                <router-outlet></router-outlet>\n            </div>\n        </div>\n    <my-app-footer></my-app-footer>\n    </div>\n</section>\n\n<!-- <my-app-customizer></my-app-customizer> -->\n\n<my-app-search-overlay></my-app-search-overlay>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/layout/layout.component.html
// module id = 1154
// module chunks = 9